module.exports = __webpack_public_path__ + "img/phone.24808e71.svg";